import { inject, observer } from "mobx-react";
import { Preloader } from "randmarcomps";
import React, { useEffect } from "react";
import { RootStore } from "../stores/rootStore";

interface IProps {
  store?: RootStore;
  children?: React.ReactNode;
}

const LoadingScreen = ({ text }: { text: string }) => (
  <Preloader className="fixed inset-0 bg-[#8E77A6]" color="white" text={text} />
);

const AuthProvider = ({ store, children }: IProps) => {
  const { userStore, manufacturerStore } = store!;
  const { user } = userStore;
  const { manufacturer } = manufacturerStore;

  useEffect(() => {
    if (user == null) {
      userStore.signIn();
    }
  }, [user, userStore]);

  useEffect(() => {
    if (manufacturer === null) {
      window.location.replace(`https://dashboard.randmar.io`);
    }
  }, [manufacturer]);

  if (user == null) {
    return <LoadingScreen text="Signing you in..." />;
  }

  if (!manufacturer) return <LoadingScreen text="Loading your profile..." />;

  return <>{children}</>;
};

export default inject("store")(observer(AuthProvider));
